export default __webpack_public_path__ + "images/membership-star.69ce3f9a9efd41855183c0c4385f87ed.png";